import { render } from "./LinkedInIcon.vue?vue&type=template&id=8035f224"
import script from "./LinkedInIcon.vue?vue&type=script&lang=js"
export * from "./LinkedInIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__